<template>
  <!--
          作者：kmdshop
          时间：2019-10-24
          描述：统计-会员统计-新增会员
      -->
  <div class="ww100 mt30">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="本年月消费" name="months"></el-tab-pane>
      <el-tab-pane label="年消费统计" name="years"></el-tab-pane>
    </el-tabs>
    <div class="d-s-c">
      <div class="d-s-c" style="margin-bottom: 10px;">
        <div style="margin-left: 30px;">所属业务员：</div>
        <el-select v-model="search" filterable placeholder="请选择操作" @change="getData" size="small">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in saler" :key="item.user_id" :label="item.nickName" :value="item.user_id"></el-option>
        </el-select>
      </div>
    </div>
    <div class="">
      <div class="Echarts"><div id="LineChart"></div></div>
    </div>




        <div class="bg-white rounded-lg shadow-sm">
        <div class="p-6 border-b border-gray-100">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-bold text-gray-800">下单记录</h2>
            <div class="flex gap-4">
            </div>
          </div>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50">
              <tr>
                <th v-for="header in tableHeaders" :key="header" 
                    class="px-6 py-4 text-left text-sm font-medium text-gray-600">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index" 
                  class="border-t border-gray-100 hover:bg-gray-50">
                <td v-for="(value, key) in row" :key="key" 
                    class="px-6 py-4 text-sm text-gray-700">
                  <div :class="{'text-blue-600': key === 'orderNo', 
                               'text-green-500': value === '已完成',
                               'text-yellow-500': value === '进行中'}">
                    {{ value }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


          <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import StatisticsApi from '@/api/statistics.js';
import { formatDate } from '@/utils/DateTime.js'
export default {
  data() {
    let endDate=new Date();
    let startDate=new Date();
    startDate.setTime(startDate.getTime()- 3600 * 1000 * 24 * 7);
    return {
      search:"",
      /*是否正在加载*/
      loading: true,
      /*类别*/
      activeName: 'months',
      /*时间快捷选项*/
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      datePicker: [formatDate(startDate,'yyyy-MM-dd'),formatDate(endDate,'yyyy-MM-dd')],
      /*数据对象*/
      dataList: null,
      /*交易统计图表对象*/
      myChart: null,
      /*图表数据*/
      option: {
        title: {
          //text: 'ECharts 入门示例'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {}
      },
      saler:[],


       tableHeaders: ['订单编号', '日期', '商品名称',  '总价', '业务员', '状态'],
        tableData: [
        ],
          /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
    };
  },
  created() {
  },
  mounted() {
    this.myEcharts();
    this.getSaler();
  },
  methods: {
    getSaler(){
      console.log("ssssssss")
      let self = this;
      StatisticsApi.getSaler(
        {},
        true
      )
        .then(res => {
          self.saler = res.data;
        })
        .catch(error => {});
    },
    /*切换*/
    handleClick(e) {
      this.getData();
    },

    /*选择时间*/
    changeDate() {
      this.getData();
    },

    /*创建图表对象*/
    myEcharts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('LineChart'));
      /*获取列表*/
      this.getData();
    },
     /*格式数据*/
    createOption() {
      if (!this.loading) {
        let names = [];
        let xAxis = this.dataList.days;
        let series1 = [];
        let series2 = [];
        this.dataList.data.forEach(item => {
          series1.push(item.total_money);
          series2.push(item.total_num);
        });
        if (this.activeName == 'months') {
          names = ['月成交额', '月成交量'];
        } else if (this.activeName == 'years') {
          names = ['年成交额', '年成交量'];
        }

        // 指定图表的配置项和数据
        this.option.xAxis = {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        };
        this.option.color=["red", "#409EFF"];

        this.option.legend = {
          data: [{ name: names[0], color: '#ccc' }, { name: names[1] }]
        };
        this.option.series = [
          {
            name: names[0],
            type: 'line',
            data: series1,
            lineStyle: {
              color: 'red'
            }
          },
          {
            name: names[1],
            type: 'line',
            data: series2,
            lineStyle: {
              color: '#409EFF'
            }
          }
        ];

        this.myChart.setOption(this.option);
        this.myChart.resize();
      }
    },
    /*获取列表*/
    getData() {
      let self = this;
      self.loading = true;

      let UserApi=null;

      if(this.activeName=='months'){
        UserApi=StatisticsApi.getMonthExpense;
      }

      if(this.activeName=='years'){
        UserApi=StatisticsApi.getYearExpense;
      }

      UserApi(
        {
          referee_id: self.search
        },
        true
      )
        .then(res => {
          self.dataList = res.data;

          self.tableData = res.data.list.data;
          self.loading = false;
          self.createOption();
        })
        .catch(error => {});
    }
  }
};
</script>

<style scoped="scoped">
.Echarts {
  box-sizing: border-box;
}
.Echarts > div {
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/expense/part/LineChart.vue